import Skeleton from 'react-loading-skeleton';

export function SidebarSkeleton() {
  const baseColor = 'rgb(245, 245, 245)';
  const highlightColor = '#fff';

  const row = (
    <div className="flex gap-2">
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} width={16} height={16} />
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} containerClassName="w-full" height={16} />
    </div>
  );

  return (
    <div className="flex flex-col gap-4">
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} height={24} />
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} height={24} />
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} height={16} width={106} />
      <div className="pl-3 flex flex-col gap-5">
        {row}
        {row}
        {row}
        {row}
        <div className="pl-4">{row}</div>
      </div>
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} height={2} />
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} height={16} width={106} />
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} height={16} />
      <div className="pl-3">
        <Skeleton baseColor={baseColor} highlightColor={highlightColor} height={16} />
      </div>
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} height={2} />
      <div className="pl-3 flex flex-col gap-4">
        {row}
        {row}
        {row}
      </div>
      <Skeleton baseColor={baseColor} highlightColor={highlightColor} height={2} />
      <div className="pl-3 flex flex-col gap-4">
        {row}
        <div className="pl-4 flex flex-col gap-4">
          {row}
          {row}
          {row}
          {row}
          {row}
        </div>
      </div>
    </div>
  );
}
